import { BaseError } from "src/contexts/_shared/domain/errors/BaseError";

export class DocumentationAreaNotFoundError extends BaseError {
  constructor() {
    super("DocumentationAreaNotFoundError");
  }
}
